jQuery(function($) {
	
	$(document).ready(function() {
		smooothScroll();
	});
	
	
	
	$(window).on( 'load', function () {
		
	});
	
	
	
	$(window).on( 'resize', function () {
		
	});
	
	
	
	
	
	
	/*--------------------------------------------------
	Smooth Scrolling
	https://css-tricks.com/snippets/jquery/smooth-scrolling/
	
	See alteration:
	https://css-tricks.com/snippets/jquery/smooth-scrolling/#comment-1587650
	---------------------------------------------------*/	
	function smooothScroll() {
		
		$(function() {
			$("a[rel^='scrolling']").click(function() {
				if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
					var target = $(this.hash);
					target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
					if (target.length) {
						$('html,body').animate({
							scrollTop: target.offset().top
						}, 1000);
						return false;
					}
				}
			});
		});
		
	}// smooothScroll
	
	
	
	
});